import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import park1 from "../assets/images/park1.jpg";

const About = () => {
  const { t } = useTranslation(["about", "translation"]);

  return (
    <div className="min-h-screen w-full">
      <div className="flex justify-center items-center w-full h-full">
        <div className="flex justify-center items-center max-w-screen-lg  py-16 px-6">
          <div className="flex flex-col h-full justify-center">
            <h1 className="font-bold text-4xl mb-4">{t("about_title")}</h1>
            {/* Name Section */}
            <div>
              <h2 className="text-2xl mb-2 font-bold">{t("the_name_title")}</h2>
              <Trans i18nKey="the_name">{t("the_name")}</Trans>
            </div>

            {/* Founder Section */}
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.5fr] gap-8 mt-6 mb-6 items-center">
              <picture>
                <img
                  src={park1}
                  alt="Nadia Omar, founder of Tuutuum"
                  className="rounded-lg shadow-lg"
                />
              </picture>
              <div className="flex flex-col space-y-4">
                <div>
                  <h2 className="text-2xl mb-2 font-bold">
                    {t("founder_title")}
                  </h2>
                  <p>
                    <Trans i18nKey="the_founder">{t("the_founder")}</Trans>
                  </p>
                  <div className="text-center px-16">
                    <p className="mt-4 mb-2 text-center">
                      {t("founders_wish_title")}
                    </p>
                    <p className="text-xl leading-7 text-center italic">
                      <Trans i18nKey="founders_wish">
                        {t("founders_wish")}
                      </Trans>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* Product Section */}
              <h2 className="text-2xl mb-2 font-bold">
                {t("the_product_title")}
              </h2>
              <p>
                <Trans i18nKey="the_product">{t("the_product")}</Trans>
              </p>
              {/* Sustainability Section */}
              <h2 className="text-2xl mb-2 mt-8 font-bold">
                {t("sustainability_title")}
              </h2>
              <p>
                <Trans i18nKey="sustainability">{t("sustainability")}</Trans>
              </p>

              <hr className="max-w-screen-xl mx-auto my-12 border-teal-300" />

              {/* Get in touch Section */}
              <div className="text-center mt-6">
                <h2 className="font-bold mb-6 text-2xl">
                  <Trans i18nKey="about_end">{t("about_end")}</Trans>
                </h2>
                <Link
                  to="/contact"
                  className="text-lg btn-main mt-4"
                >
                  {t("get_in_touch")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
